import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanDeactivate} from '@angular/router';
import {combineLatest, filter, map, mergeMap, Observable, of, tap} from 'rxjs';
import {LogService} from '@comm-apps/log';
import {ConfirmationComponent} from '../../../../shared-ui/src/lib/dialogs/confirmation/confirmation.component';
import {MatDialog} from '@angular/material/dialog';
import {DirtyComponent} from '../classes/dirty-component';

@Injectable({
  providedIn: 'root'
})
export class DirtyGuard implements CanDeactivate<any> {
  constructor(
    private log: LogService,
    private router: Router,
    public dialog: MatDialog,
  ) { }

  public canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!component) {
      return true;
    }

    if (!('isDirty' in component)) {
      this.log.warn("You have added the DirtyGuard to your route, but your component has not extended the DirtyComponent.");
    }

    if (!component.isDirty()) {
      return true;
    }

    return component.showAlert().pipe(
      mergeMap(res => combineLatest([of(res), res === 'yes' ? component.saveFromGuard() : of(false)])),
      map(([res, saveRes]) => res && res !== 'cancel'),
    );
  }

}
